export default __webpack_public_path__ + "static/media/storage.a9a4a3f7.svg";